module.exports = __webpack_public_path__ + "img/p24.203ca585.png";